module.exports = __webpack_public_path__ + "img/phone-volume-solid.0e94024f.svg";